import React from 'react';
import { Badge as ReactBadge } from 'reactstrap';
import clsx from 'clsx';

const Badge = ({ className, color = 'light-primary', children, style }) => {
	return (
		<ReactBadge
			style={{
				minWidth: '100px',
				width: '130px',
				padding: '5px 25px 5px 25px',
				whiteSpace: 'initial',
				wordBreak: 'keep-all',
				borderRadius: '5px',
				fontSize: '12px',
				fontFamily: 'Montserrat SemiBold',
				...style
			}}
			color={color}
		>
			{children}
		</ReactBadge>
	);
};

export default Badge;
